import {  DestroyRef } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

export abstract class Utility {

    public static getLocalTimeZone(): string {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return timeZone;
    }
    public static setMoveToEnquiryElement(): void {
        localStorage.setItem('isMove', 'true');
    }
    public static isMoveToEnquiryElement(): boolean {
        const isMove = localStorage.getItem('isMove');
        return isMove ? true : false;
    }
    public static removeMoveToEnquiryElement(): void {
        localStorage.removeItem('isMove');
    }
}

export function autoUnsubWith<T = unknown>(ref: DestroyRef) {
  return takeUntilDestroyed<T>(ref);
}